import React from 'react'
import './Video.css'

function Video({norton, slug, mp4, vtt, onPlay, aspectRatio, width, height, style, ...props}, ref) {
  if (aspectRatio === undefined) {
    aspectRatio = Number(width) / Number(height)
    if (isNaN(aspectRatio)) {
      aspectRatio = 16/9
    }
  }
  let padding = (1 / aspectRatio * 100) + "%"
  if (isNaN(aspectRatio) || aspectRatio === 0) {
    padding = "100%"
  }
  console.log("Video padding:", aspectRatio, padding)

  let vref = React.useRef(null)
  let [hidden, setHidden] = React.useState(false)
  React.useImperativeHandle(ref, ()=>({
    pause: () => {
      vref.current && vref.current.pause && vref.current.pause()
      if (norton) {
        onPlay()
      }
    },
    play: () => {
      vref.current && vref.current.play && vref.current.play()
      onPlay()
    },
    show: () => {
      setHidden(false)
      if (norton) {
        onPlay()
      }
    },
    hide: () => {
      setHidden(true)
      if (norton) {
        onPlay()
      }
    }
  }))

  const getVideo = ()=>{
    if (norton) {
      if (slug === undefined) {
        throw new Error("Video: prop `slug` is required.")
      }
      return <iframe 
        ref={vref}
        frameBorder="0" 
        scrolling="auto" 
        allowFullScreen 
        src={`https://player.wwnorton.com/iframe?playertype=video&file=${slug}.mp4&ccurl=${slug}.vtt&imageurl=${slug}.jpg`}
      />
    }
    // else {
    //   if (slug === undefined) {
    //     if (mp4 === undefined) {
    //       throw new Error("Video: prop `mp4` is required.")
    //     }
    //   } else {
    //     return <video
    //       ref={vref}
    //       style={{ width: "100%", marginTop: "10px" }}
    //       controls
    //       controlsList="nodownload"
    //       onContextMenu={(e)=>e.preventDefault()}
    //       onPlay={onPlay}
    //       {...props}
    //     >
    //       <source src={`https://services.wwnorton.com/aws//?file=${slug}.mp4`} type="video/mp4" />
    //       <track src={`https://services.wwnorton.com/aws//?file=${slug}.vtt`} label="English" kind="subtitles" srcLang="en" />
    //     </video>
    //   }

      return <video
        ref={vref}
        style={{ width: "100%", marginTop: "10px" }}
        controls
        controlsList="nodownload"
        onContextMenu={(e)=>e.preventDefault()}
        onPlay={onPlay}
        {...props}
      >
        <source src={mp4} type="video/mp4" />
        <track src={vtt} label="English" kind="subtitles" srcLang="en" />
      </video>
  }
  
  if (hidden) {
    return <div ref={vref}/>
  }

  if (!norton) {
    return getVideo()
  }

  return <div className="video-outer" style={{
    width: width, 
    height: height,
    ...style,
  }}>
    <div className="video-inner" style={{
      paddingTop: padding,
    }}>
      {getVideo()}
    </div>
  </div>
}
Video = React.forwardRef(Video)
export default Video